import blocksActive from './blocks-active.png';

interface Properties {
  width?: number;
  height?: number;
}

/**
 * Active (selected) nav-tab state: icon exported directly from Figma
 * (image 9, node 74431:2212). Pairs with `BlocksIcon` for the resting state.
 */
const BlocksIconActive = ({ width = 16, height = 16 }: Properties) => {
  return <img src={blocksActive} alt='' width={width} height={height} />;
};

export default BlocksIconActive;
